import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RadioGroup } from 'components';
import {
    selectCurrencies,
    selectPreferredCurrency,
    setPreferredCurrency
} from 'tradera-state/multi-currency';
import { useTranslator } from 'static/script/app/lang';
import CurrencyIcon from '@tradera/blueprint/theme/icons2/currency.svg?jsx';

export const CurrencySelect = ({
    idPrefix,
    currencies,
    preferredCurrency,
    onCurrencySelected,
    className
}) => {
    const { t } = useTranslator();
    return (
        <div className={className}>
            <div className="d-flex align-items-center">
                <CurrencyIcon className="icon icon-md" />
                <strong className="ml-4">{t('siteHeader_currency')}</strong>
            </div>
            <RadioGroup
                id={`${idPrefix}-currency-group`}
                options={currencies.map(currency => ({
                    name: ` ${currency.shortName} - ${currency.longName}`,
                    value: currency.code
                }))}
                checked={preferredCurrency.code}
                handleOnChange={onCurrencySelected}
                className="form-check-sm mt-3 ml-3"
                radioButtonClassName="form-check-sm"
            />
        </div>
    );
};

CurrencySelect.propTypes = {
    idPrefix: PropTypes.string.isRequired,
    currencies: PropTypes.arrayOf(
        PropTypes.shape({
            code: PropTypes.string,
            shortName: PropTypes.string,
            longName: PropTypes.string
        })
    ),
    preferredCurrency: PropTypes.shape({
        code: PropTypes.string
    }),
    onCurrencySelected: PropTypes.func.isRequired,
    className: PropTypes.string
};

CurrencySelect.defaultProps = {
    className: ''
};

const mapStateToProps = state => ({
    currencies: selectCurrencies(state),
    preferredCurrency: selectPreferredCurrency(state)
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    onCurrencySelected: (code, e) => {
        dispatch(setPreferredCurrency(code));
        ownProps.onCurrencySelected && ownProps.onCurrencySelected(code, e);
    }
});

export const ConnectedCurrencySelect = connect(
    mapStateToProps,
    mapDispatchToProps
)(CurrencySelect);
